import { Flex, Spinner } from '@grupoboticario/flora-react'

interface LoadingFullProps {
  /** Tamanho do Loading com a diferença do Header */
  withHeader?: boolean
}

export const LoadingFull = ({ withHeader }: LoadingFullProps) => (
  <Flex
    align="center"
    justify="center"
    css={{
      minHeight: withHeader ? 'calc(100vh - 114px)' : '100vh',
      width: '100%',
    }}
    role="progressbar"
  >
    <Spinner
      size="xl"
      color="$backgroundAltPrimary"
    />
  </Flex>
)
